import { styled } from '@mui/material';
import { PropertyGeneralAddressCard } from '../../styled';

export const ExchangeSectionWrapper = styled(PropertyGeneralAddressCard)({
	display: 'grid',
	width: '320px',
});
